import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import BankFindSort from "../components/BankFind/BankFindSort";
import { All } from "../interfaces";

export function mapStateToProps({ appState }: All) {
  return {
    appState: appState.bankFind,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateSort: (newSortField: string, newSortOrder: string) => {
      dispatch(actions.updateSortOrder(newSortField, newSortOrder));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(BankFindSort);
